/* eslint-disable max-len */
import {
  Box, Typography, TextField, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import OfflinePlayerCard from './OfflinePlayerCard';

const getWinPercentage = (player) => {
  const totalGames = (player.wins || 0) + (player.losses || 0);
  if (totalGames === 0) return 0;
  return (player.wins || 0) / totalGames;
};

export function PlayersOffline({ ranking, isAdmin }) {
  const players = useSelector((state) => state.players);
  const [filter, setFilter] = useState('');
  const [sortBy, setSortBy] = useState('points');

  const isRankingOrAdmin = ranking || isAdmin;

  const playersOffline = isRankingOrAdmin ? [...players] : players.filter((p) => !p.checkedIn);

  if (ranking || isAdmin) {
    if (sortBy === 'points') {
      playersOffline.sort((a, b) => (b.totalPoints ?? (b.wins - b.losses)) - (a.totalPoints ?? (a.wins - a.losses)));
    } else if (sortBy === 'winRate') {
      playersOffline.sort((a, b) => getWinPercentage(b) - getWinPercentage(a));
    }
  }

  // Function to handle the change in the search input
  const handleSearchChange = (event) => {
    setFilter(event.target.value);
  };

  // Filter players based on the search input
  const filteredPlayers = playersOffline.filter((player) => player.playerName.toLowerCase().includes(filter.toLowerCase()));

  return (
    <Box
      sx={{
        mt: 4,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h5" textAlign="center">
        {ranking ? 'Ranking de Jogadores' : 'Jogadores fora da quadra'}
      </Typography>

      {ranking && (
        <FormControl sx={{ mt: 2, minWidth: 200 }} size="small">
          <InputLabel>Ordenar por</InputLabel>
          <Select
            value={sortBy}
            label="Ordenar por"
            onChange={(e) => setSortBy(e.target.value)}
          >
            <MenuItem value="points">Mais Pontos</MenuItem>
            <MenuItem value="winRate">Maior Aproveitamento</MenuItem>
          </Select>
        </FormControl>
      )}

      {/* Search Input */}
      <TextField
        label="Filtrar por nome"
        variant="outlined"
        value={filter}
        onChange={handleSearchChange}
        sx={{ mt: 2, mb: 2, width: '80%' }}
        fullWidth
      />

      <Box
        sx={{
          mt: 2,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {filteredPlayers.length > 0 ? (
          filteredPlayers.map((player, index) => (
            <OfflinePlayerCard player={player} position={index + 1} ranking={ranking} isAdmin={isAdmin} />
          ))
        ) : (
          'Nenhum jogador encontrado'
        )}
      </Box>
    </Box>
  );
}
